import React from "react";
import "./sustainability.css";

const Sustainability = () => {
  return (
    <>
      <div>Sustainability</div>
    </>
  );
};

export default Sustainability;
